<template lang="pug">
  div.social-image-readiness
    strong.block.text-sm.font-semibold.text-heading Social images
    p.mt-1.text-sm(v-if="ready") All added. Your landing page is ready to share.
    p.mt-1.text-sm(v-else) Add {{ missing.length === 1 ? "this image" : "these images" }} so your landing page stands out when shared on social media.
    ul.mt-4.space-y-2.text-sm
      li.flex.items-center(v-for="image in images", :key="image.key")
        Icon(
          :icon="image.added ? 'circle-check' : 'circle-exclamation'",
          :class="image.added ? 'text-green-600' : 'text-orange-600'",
          class="mr-3 text-base"
        )
        span.flex-1.text-heading {{ image.label }}
        span(:class="image.added ? 'text-supplement' : 'font-semibold text-orange-600'") {{ image.added ? "Added" : "Missing" }}
    Button(v-if="canDesign", type="link", prepend-icon="palette", @click="$emit('design')") Add in Design
</template>

<script>
// Matches the order of the Social section in the explore editor.
export const socialImageTypes = [
  { key: "vertical", label: "Vertical" },
  { key: "square", label: "Square" },
  { key: "horizontal", label: "Horizontal" }
]

/**
 * Returns the labels of the social images a collection is missing, or null
 * when the API hasn't provided the collection's `social_images` status.
 */
export function missingSocialImages(collection) {
  const status = collection && collection.social_images
  if (!status) return null
  return socialImageTypes.filter(({ key }) => !status[key]).map(({ label }) => label)
}

export default {
  props: {
    collection: {
      type: Object,
      required: true
    },
    canDesign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    images() {
      return socialImageTypes.map(({ key, label }) => ({ key, label, added: !!this.collection.social_images[key] }))
    },
    missing() {
      return this.images.filter(image => !image.added)
    },
    ready() {
      return this.missing.length === 0
    }
  }
}
</script>
